<template>
  <div class="col-12 d-flex p-0 flex-wrap">
    <Modal v-if="showDeleteChargesModal" @close="showDeleteChargesModal = false">
      <template v-slot:header>
        <div class="d-flex justify-content-between w-100 align-items-center">
          <div></div>
          <h3 class="fs-3 fw-bold">Delete Charges</h3>
          <button class="btn btn-gray btn-xl" @click="showDeleteChargesModal = false">
            <i class="fa fa-close"></i>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <div class="d-flex flex-column align-items-center col-12" v-if="charges.length > 0">
          <p class="fs-5">Are you sure you want to delete these charges?</p>
          <p class="fs-5 mt-3">
            This action cannot be undone.
          </p>
          <div class="d-flex mt-3">
            <loading-button style="height: 30px" class="mr-3" v-if="loading"></loading-button>
            <button v-else class="btn btn-primary mr-3" @click="
              deleteAllCharges
            ">Delete All Charges</button>
            <button class="btn btn-outline" @click="showDeleteChargesModal = false">
              Cancel
            </button>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center col-12" v-else>
          <p class="fs-5">You have no charges to delete yet.</p>
        </div>
      </template>
    </Modal>
    <Modal v-if="showEditCaseInfoModal" @close="showEditCaseInfoModal = false">
      <template v-slot:header>
        <div class="d-flex justify-content-between w-100 align-items-center">
          <div></div>
          <h3 class="fs-3 fw-bold">Edit Case Info</h3>
          <button class="btn btn-gray btn-xl" @click="showEditCaseInfoModal = false">
            <i class="fa fa-close"></i>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <NewCase class="case-popup pl-0" :app_token="token" :newCaseFlag="false" :currentCase="caseSelected"
          :organizationSettings="organizationSettings" />
      </template>
    </Modal>
    <div class="fs-5 p-0 m-0 d-flex flex-column card fs-5 col-12 col-lg-6 p-0 pl-5">
      <h1 class="section-header fw-bold my-3">Tools </h1>
      <div class="d-flex w-100 flex-column card-body">
        <!-- <div class="d-flex">
          <div class="d-flex flex-column mr-5">
            <h4 class="fs-3 fw-bold">Prior Strikes</h4>
            <p class="">Number of prior strikes (prior serious or violent felony convictions).</p>
            <div class="d-flex mb-4 w-100 ">
   


            </div>
            <div class="d-flex w-100 flex-column" v-if="
              charges.findIndex(
                (chg) => chg.NumberOfStrikes == '2+' || chg.NumberOfStrikes == '2+!'
              ) > -1
            ">
              <label class="mb-0 fw-bold" for="superStrike">Are any of the prior strikes a Super Strike?
                <i class="fa fa-info-circle book_auth" @click="
                  emitPopupText({
                    header: 'PC 1170.12',
                    body: `(iv) The defendant suffered a prior conviction, as defined in subdivision (b), for any of the following serious or violent felonies:
      
                      (I) A “sexually violent offense” as defined by subdivision (b) of Section 6600 of the Welfare and Institutions Code.
                      
                      (II) Oral copulation with a child who is under 14 years of age, and more than 10 years younger than the defendant as defined by Section 287 or former Section 288a, sodomy with another person who is under 14 years of age and more than 10 years younger than the defendant as defined by Section 286, or sexual penetration with another person who is under 14 years of age and more than 10 years younger than the defendant as defined by Section 289.
                      
                      (III) A lewd or lascivious act involving a child under 14 years of age, in violation of Section 288.
                      
                      (IV) Any homicide offense, including any attempted homicide offense, defined in Sections 187 to 191.5, inclusive.
                      
                      (V) Solicitation to commit murder as defined in Section 653f.
                      
                      (VI) Assault with a machinegun on a peace officer or firefighter, as defined in paragraph (3) of subdivision (d) of Section 245.
                      
                      (VII) Possession of a weapon of mass destruction, as defined in paragraph (1) of subdivision (a) of Section 11418.
                      
                      (VIII) Any serious or violent felony offense punishable in California by life imprisonment or death.`,
                  })
                  "></i>
              </label>
             
            </div>
          </div>

        </div> -->
        <div class="d-flex flex-column mr-5 mb-5">
          <h4 class="fs-4 fw-bold">Adjust Count Numbers </h4>
          <p class="mb-3">Change count numbers of your charges by shifting them up or down.</p>
          <div class="mb-3">
            <button class="btn btn-primary btn-xl mr-3" @click="$emit('showCountNumberFixer')">
              Adjust Count Numbers
            </button>
            
          </div>
          <h4 class="fs-4 fw-bold">Insert Charge  </h4>
          <p class="mb-3">If you skipped a charge, you can insert a new one.</p>
          <div>
            <button class="btn btn-primary mr-3" @click="showInsertCountNumberOption = true">
                Insert Charge
            </button>
            
          </div>
          <div v-if="showInsertCountNumberOption" class=" pl-5 d-flex mt-3 align-items-end">
                <div class="d-flex flex-column">
                    <label class="fs-5 fw-bold" for="selectedCountNumberToInsertAt">Count:</label>
                    <input type="number" class="form-control" style="max-width: 80px" :min="1"
                        id="selectedCountNumberToInsertAt" v-model="selectedCountNumberToInsertAt" />
                </div>
                <div>
                    <button class="btn btn-primary mx-3" @click="emitInsertChargeBetweenCounts">Insert</button>
                    <button class="btn btn-primary-outline" @click="showInsertCountNumberOption = false">Cancel</button>
                </div>

            </div>
        </div>
        <div class="d-flex flex-column mr-5 mb-5">
          <h4 class="fs-4 fw-bold">Edit Multiple Charges </h4>
          <p class="mb-3">Select charge and concurrency status on multiple counts simultaneously.</p>
          <div>
            <button class="btn btn-primary btn-xl" @click="$emit('showUpdateMultiple')">
              Edit Charges
            </button>
          </div>

        </div>
        <div class="d-flex flex-column mr-5 mb-5">
          <h4 class="fs-4 fw-bold mb-3">Delete All Charges </h4>
          <!-- <p class="mb-3">Select charge and concurrency status on multiple counts simultaneously.</p> -->
          <div>
            <button class="btn btn-primary btn-xl" @click="showDeleteChargesModal = true">
              Delete All Charges
            </button>
          </div>

        </div>
        
        <!-- <div class="d-flex flex-column mr-5 mb-5">
          <h4 class="fs-4 fw-bold">Run Misdemeanors Concurrent <i class="button-color">New!</i></h4>
          <p class="">Have Misdemeanors default to running concurrently with felony charges.</p>
          <div>
            <button class="btn btn-primary btn-xl">
              Run Misdemeanors Concurrent
            </button>
          </div>

        </div> -->
        <h1 class="section-header fw-bold my-3">Settings </h1>
        <div class="d-flex flex-column mb-5">
          <h4 class="fs-4 fw-bold ">Status Enhancement Application
            <i class="fa fa-info-circle clickable fs-4" @click="
                  emitPopupText({
                    header: 'Status Enhancement Application',
                    body: `See <i>People v Williams</i> (2004), 34 Cal. 4th 397 and <i>People v Misa</i> (2006), 140 Cal. App. 4th 837`,
                  })"></i>
            
          </h4>
          <p>Status Enhancements may be applied multiple times in a case with indeterminate charges.
            
            <!-- <br>Would you like to apply this rule in this case? -->
          </p>
          <div class="d-flex"  v-if="statusEnhancements.length > 0 && charges.findIndex((chg) => isIndeterminate(chg)) !== -1 ">
            <button class="btn btn-xl mr-3" @click="toggleTomsStupidRule(true)"
              :class="caseSelected.caseAttributes?.tomsStupidRule === true || caseSelected.caseAttributes?.tomsStupidRule === undefined ? 'btn-primary' : 'btn-primary-outline'">Apply</button>
            <button class="btn btn-xl" @click="toggleTomsStupidRule(false)"
              :class="caseSelected.caseAttributes?.tomsStupidRule === true || caseSelected.caseAttributes?.tomsStupidRule === undefined ? 'btn-primary-outline' : 'btn-primary'">Don't
              Apply</button>
          </div>
          <p v-else class="mb-3">This rule does not apply in this case.</p>
        </div>

        <!-- Edit Case Button -->
        <!-- <div class="d-flex flex-column">
          <h3 class="fs-3 fw-bold">Case Info</h3>
          <div>
            <button class="btn btn-primary" @click="showEditCaseInfoModal = true">Edit Case Info</button>
          </div>

        </div> -->
        <!-- <h4 class="fs-3 fw-bold mt-5">Update Multiple Charges</h4>
        <p>Select and update multiple charges at once</p>
        <div>
          <button class="btn btn-primary" @click="showUpdateMultipleCharges = true">Update Multiple
            Charges</button>

        </div> -->



      </div>


    </div>
    <div class="d-flex flex-column border-left col-12 col-lg-6 p-0 " v-if="!loading">

      <h1 class="section-header fw-bold my-3 pl-4">Edit Case Info</h1>
      <NewCase class="case-popup pl-0" :app_token="token" :newCaseFlag="false" :currentCase="caseSelected"
        :organizationSettings="organizationSettings" />
    </div>

  </div>



</template>
<script>
import CPKSelector from "./CPKSelector.vue";
import axios from "axios";
import SC from "../../../components/utils/sharedComponent.vue";
import Modal from "../../../components/utils/Modal.vue";
import NewCase from '../NewCase.vue'
import UpdateMultipleCharges from './UpdateMultipleCharges.vue'
import { handleError } from "../../../helpers";
export default {
  name: "CaseSettings",
  components: { CPKSelector, SC, Modal, NewCase, UpdateMultipleCharges },
  props: ["charges", "user_token", "caseSelected", "selectedCharge", "loading", "organizationSettings"],
  data() {
    return {
      selectedTab: "CPKSelector",
      priorPrisonTerms: 0,
      currentCase: {},
      isGang: this.caseSelected?.IsGang,
      showSuperStrikePopup: false,
      weirdStirCharges: [],
      token: localStorage.getItem("user_token"),
      // organizationSettings: {},
      loading: false,
      showUpdateMultipleChargesModal: false,
      showEditCaseInfoModal: false,
      showInsertCountNumberOption: false,
      selectedCountNumberToInsertAt: 1,
      showInsertCountNumberCrimeModal: false,
      showDeleteChargesModal: false,
    };
  },
  computed: {
    showSuperStrikePopup() {
      return this.charges.findIndex(
        (chg) => chg.NumberOfStrikes == "2+!"
      ) > -1;
    },
    statusEnhancements() {
      return this.charges.filter(chg => chg.CrimeTypeId == 1)
    },

  },
  methods: {

    handleDeleteClick() {
      if (!this.confirmDelete) {
        this.confirmDelete = true;

        setTimeout(() => {
          this.confirmDelete = false;
        }, 2500);
      } else {
        this.deleteAllCharges();
        this.confirmDelete = false;
      }
    },

    emitInsertChargeBetweenCounts(){
      this.$emit('insertChargeBetweenCounts', this.selectedCountNumberToInsertAt)
    },
    toggleTomsStupidRule(bool) {
      // console.log(this.currentCase)
      if (this.currentCase.caseAttributes === undefined) {
        this.currentCase.caseAttributes = {};
      }
      this.currentCase.caseAttributes.tomsStupidRule = bool;
      const updateCase = axios.put(
        process.env.VUE_APP_ENDPOINT + `/api/cases/${this.currentCase.Id}`,
        {
          Id: this.currentCase.Id,
          caseAttributes: this.currentCase.caseAttributes,
        },
        {
          headers: { Authorization: `Bearer ` + this.token },
        }
      );
      this.$nextTick(() => {
        this.$emit("onCalc");
      });
    },
    refreshCharges() {
      // console.log("factor refresh");
      this.$emit("refereshCharges");
    },
    emitSelectCharge(index) {
      // console.log("sees emit in factor", index);
      this.$emit("selectCharge", index);
    },

 
    emitPopupText(obj) {
      this.$emit("displayModalPopup", obj);
    },
    async runStirCalculation(chg) {
      if (
        chg?.RunSTIRCalculation === undefined ||
        !chg?.RunSTIRCalculation
      ) {
        chg.RunSTIRCalculation = true;
      } else {
        chg.RunSTIRCalculation = true;
      }
      const postedChg = await SC.postChargeField(
        this.token,
        chg.Id,
        "RunSTIRCalculation",
        chg.RunSTIRCalculation
      );
      this.emitCalc();
    },
    emitCalc() {
      // console.log('EMITS CALC')
      this.$emit("onCalc");
    },
    async selectViolentPriors(priors) {
      this.currentCase.ViolentPriors = priors;
      // console.log(this.currentCase);
      await axios
        .put(
          process.env.VUE_APP_ENDPOINT + `/api/cases/${this.currentCase.Id}`,
          {
            Id: this.currentCase.Id,
            ViolentPriors: priors,
          },
          {
            headers: { Authorization: `Bearer ` + this.token },
          }
        )
        .then((result) => {
          // console.log(result);
        });
      this.$emit("onCalc");
    },
    deleteAllCharges() {
      this.$emit("deleteAllCharges");
    },
    deleteCharges(charges) {
      // console.log(charges);
      const sortedCharges = charges.toSorted((a, b) => b.CrimeTypeId - a.CrimeTypeId)
      // console.log(sortedCharges.map(chg => {
      //   return {
      //     CountNumber: chg.CountNumber,
      //     sectionNumber: chg.statuteDefinitionSection,
      //   }
      // }))
      sortedCharges.forEach(charge => {
        this.$emit("onTrashCharge", charge.Id, charge, true);
      })
    },
    // async fetchOrganizationSettings() {
    //   const user_atr = JSON.parse(localStorage.getItem("user_attr"));
    //   if (user_atr?.Subscriber?.SubscriptionType !== 3) {
    //     return;
    //   }
    //   const response = await axios
    //     .get(process.env.VUE_APP_ENDPOINT + "/api/org/fetchOrganizationSettings", {
    //       headers: {
    //         Authorization: `Bearer ` + localStorage.getItem("user_token"),
    //       },
    //     })
    //     .catch(handleError);
    //   this.organizationSettings = response.data;
    //   // console.log('Organization Settings:', this.organizationSettings);
    // },
    isIndeterminate(chg) {
      return SC.isIndeterminate(chg);
    }
  },
  watch: {
    // isGang: async function (val, oldVal) {
    //   this.currentCase.IsGang = val;
    //   await axios
    //     .put(
    //       process.env.VUE_APP_ENDPOINT + `/api/cases/${this.currentCase.Id}`,
    //       {
    //         Id: this.currentCase.Id,
    //         IsGang: val,
    //       },
    //       {
    //         headers: { Authorization: `Bearer ` + this.token },
    //       }
    //     )
    //     .then((result) => {
    //       // console.log(result);
    //     });
    //   // console.log(this.currentCase);
    // },

  },
  async mounted() {
    // console.log(this.selectedCharge);
    // console.log("CASE", this.caseSelected);
    this.loading = true;
    this.token = localStorage.getItem("user_token");
    this.currentCase = this.caseSelected;
    this.charges.forEach((chg) => {
      if (
        chg.CrimeSeverityId == 3 &&
        chg.SubordinateSTIRFactor != 3 &&
        chg.CrimeTypeId == 5
      ) {
        this.weirdStirCharges.push(chg);
      }
    });
    // await this.fetchOrganizationSettings()
    this.loading = false;
    // console.log("WEIRD STIRS: ", this.weirdStirCharges);
  },
};
</script>
<style scoped></style>
